import type { Cue, Viseme } from "../model/face";

// Ported from the lip sync lab (../index.html): frame f shows the mouth Rhubarb gives for (f/fps + lead),
// then runs shorter than the min hold are absorbed. Settings Luke liked: 24 fps, 1-frame hold, 60 ms lead.
export function visemeFrames(cues: Cue[], duration: number, fps = 24, hold = 1, lead = 0.06): Viseme[] {
  if (!cues.length) return [];
  const n = Math.ceil(duration * fps);
  const seq: Viseme[] = [];
  for (let f = 0; f < n; f++) {
    const t = f / fps + lead;
    const c = cues.find(c => t >= c.start && t < c.end) || cues[cues.length - 1]!;
    seq.push(c.value);
  }
  const runs: { v: Viseme; n: number }[] = [];
  for (const v of seq) {
    const r = runs[runs.length - 1];
    if (r && r.v === v) r.n++;
    else runs.push({ v, n: 1 });
  }
  // A short run borrows frames from the next run, or folds into the last run kept; equal neighbours merge.
  const kept: { v: Viseme; n: number }[] = [];
  for (let i = 0; i < runs.length; i++) {
    const r = runs[i]!, next = runs[i + 1], last = kept[kept.length - 1];
    if (r.n < hold) {
      if (next && next.n - (hold - r.n) >= hold) {
        next.n -= hold - r.n;
        r.n = hold;
      } else if (last) {
        last.n += r.n;
        continue;
      }
    }
    if (last && last.v === r.v) last.n += r.n;
    else kept.push(r);
  }
  const out: Viseme[] = [];
  for (const r of kept) for (let j = 0; j < r.n; j++) out.push(r.v);
  return out;
}
